import '@babel/polyfill';
// Vue
import Vue from 'vue';
import App from './App';


// 配置
import Setting from './setting';

// 混合
import mixinApp from '@/mixins/app';

// 插件
import plugins from '@/plugins';

// store
import store from '@/store/index';

// iView 和 iView Pro
import ViewUI from 'view-design';
import iViewPro from '@/libs/iview-pro/iview-pro.min.js';
import uploader from 'vue-simple-uploader'

// 菜单和路由
import router from './router';
import menuHeader from '@/menu/header';
import menuSider from '@/menu/sider';
import { frameInRoutes } from '@/router/routes';

import { jsonParse, merge } from '@/libs/common';

//引入自定义全局样式
import './assets/styles/index.less'

// 方法
import { getHeaderName, getMenuSider, getSiderSubmenu } from '@/libs/system';

// 内置组件
import iLink from '@/components/link';
import iFrame from '@/components/frame';

// jsonp跨域支持
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme
import './styles/index.less';
import './libs/iview-pro/iview-pro.css';

// 引入AgileBPM 自身的组件
import AbGlobalComponents from '@/components/ab-global-components'
Vue.use(AbGlobalComponents);

import BaiduMap from "vue-baidu-map";
import TlbsMap from 'tlbs-map-vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import axios from 'axios'

Vue.use(plugins);
Vue.use(ElementUI, { size: 'medium' });
Vue.use(Avue, { axios, crudOption: {} })
Vue.use(uploader);

Vue.use(ViewUI, {
  size: 'default',
});
Vue.use(iViewPro);
Vue.component('i-link', iLink);
Vue.component('i-frame', iFrame);
Vue.prototype.$merge = merge;
// 百度地图
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "41wOC7dh3MeM8s2ZVRfTdxdcV6ighjHr",
});
//腾讯地图
Vue.use(TlbsMap);
function showLoading(text) {
  this.$Spin.show({
    render: (h) => {
      return h('div', {
        class: 'spin-box'
      }, [
        h('Icon', {
          'class': 'spin-icon-load',
          props: {
            type: 'ios-loading',
            size: 18,
            color: '#fff'
          }
        }),
        h('div', {
          style: 'color: #fff;font-size:16px;'
        }, text || '保存中…')
      ]);
    }
  });
}

function hideLoading() {
  this.$Spin.hide();
}
Vue.prototype.showLoading = showLoading;
Vue.prototype.hideLoading = hideLoading;

Vue.config.productionTip = false;

//拦截不知原因的警告报错
Vue.config.warnHandler = function (warnTxt, vm, info) {
  // console.log('warnTxt => ', warnTxt);
  // console.log('vm => ', vm);
  // console.log('info => ', info);
  let msg = `Invalid prop: custom validator check failed for prop "sortOrders"`
  if (warnTxt.includes(msg)) {
    return
  } else {
    console.error("[Vue warn]: " + warnTxt + info)
  }
};

let vueMain = new Vue({
  mixins: [mixinApp],
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('admin/page/init', frameInRoutes);
    // 设置顶栏菜单
    this.$store.commit('admin/menu/setHeader', menuHeader);
    // 加载用户登录的数据
    this.$store.dispatch('admin/account/load');
    // 初始化全屏监听
    this.$store.dispatch('admin/layout/listenFullscreen');
    this.getConfigInfos();
    this.getPassWordRule();
  },
  methods: {
    // 查询当前系统参数配置列表
    getConfigInfos() {
      this.abHttpUtil.postForm("/wps/configInfo").then(result => {
        localStorage.setItem('systemConfigInfos', JSON.stringify(result));
      })
        .catch(error => {
        });
      // this.changeFavicon();
    },
    changeFavicon() {// 修改系统图标
      const head = document.getElementsByTagName('head')[0];
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = JSON.parse(localStorage.getItem('systemConfigInfos')).favicon;

      head.appendChild(link);
    },
    getPassWordRule() {
      this.abHttpUtil
        .postForm("/sys/tools/getPassWordRule")
        .then(
          (result) => {
            if (result.isOk) {
              this.$store.commit('admin/page/setCheckingRuleKey', "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$");
              this.$store.commit('admin/page/setCheckingRuleTxt', "密码必须含数字、大小写英文、特殊字符4种且大于8位");
            }
          },
          function (status) {
            if (status == !0) {
              this.$Message.error("加载失败！" + status);
            }
          }
        );
    },
    // // 设置系统配置信息
    // setSystemConfigInfos(state, data) {
    //     state.systemConfigInfos = data;
    //     localStorage.systemConfigInfos = JSON.stringify(data);
    // },
  },
  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    '$route'(to, from) {
      let path = to.matched[to.matched.length - 1].path;
      if (!Setting.dynamicSiderMenu) {
        let headerName = getHeaderName(path, menuSider);
        if (headerName === null) {
          path = to.path;
          headerName = getHeaderName(path, menuSider);
        }
        // 在 404 时，是没有 headerName 的
        if (headerName !== null) {
          this.$store.commit('admin/menu/setHeaderName', headerName);
          this.$store.commit('admin/menu/setMenuSider', menuSider);

          const filterMenuSider = getMenuSider(menuSider, headerName);
          this.$store.commit('admin/menu/setSider', filterMenuSider);
          this.$store.commit('admin/menu/setActivePath', to.fullPath);
          const openNames = getSiderSubmenu(path, menuSider);
          this.$store.commit('admin/menu/setOpenNames', openNames);
        }
      }
      this.appRouteChange(to, from);
    }
  }
}).$mount('#app');

export { vueMain };
